<template>
  <div id="page-container">
    <component :is="currentContainer">
      <router-view v-if="isRouterAlive" />
    </component>
  </div>
</template>

<script setup lang="ts">
import { isMobile } from "@common_lib/base/utils/src/tools"
import { sendMessage } from "@/composables/useBridge"
import { safeLocalStorage } from "@/utils/safeStorage"

const googleAnalytics = useGoogleAnalytics()

useModalStore()
useNavbarStore()

useFraudProtectionSystem()
useReceiveMessage()
useWebsiteErrorRedirect()

// PostMessage 處理 iframe 關閉訊息
const { handleIframeCloseQuery } = usePostMessage()
handleIframeCloseQuery()

const {
  shouldLoadJBLScript,
  hasMountedJBL,
  loadJBLScript,
  initJBLWebSocket,
  fetchRecommendLine
} = useJBLWebSocket()

useChangeLine({
  shouldLoadJBLScript,
  hasMountedJBL,
  loadJBLScript,
  initJBLWebSocket,
  fetchRecommendLine
})

useChat()

const components = {
  MobileContainer: defineAsyncComponent(() => import("@/layouts/mobile/Container.vue")),
  DesktopContainer: defineAsyncComponent(() => import("@/layouts/desktop/Container.vue"))
}

const currentContainer = computed(() =>
  isMobile() ? components.MobileContainer : components.DesktopContainer
)

const websiteInfoStore = useWebsiteInfoStore()
const { isRouterAlive, state } = storeToRefs(websiteInfoStore)
const authStore = useAuthStore()
const { isLogin, certification } = storeToRefs(authStore)
const { fetchAccountTracker } = useFetchAccountTracker()
const { fetchFingerprintPro } = useFetchFingerprintPro()

const ACCOUNT_TRACKER_CALLED_KEY = "accountTrackerCalled"

const callTrackingAPIs = () => {
  if (safeLocalStorage.getItem(ACCOUNT_TRACKER_CALLED_KEY)) return
  safeLocalStorage.setItem(ACCOUNT_TRACKER_CALLED_KEY, "true")
  fetchAccountTracker().catch(err =>
    console.error("[App] accountTracker API failed", err)
  )
  fetchFingerprintPro().catch(err =>
    console.error("[App] fingerprintPro API failed", err)
  )
}

watch(
  () => state.value.userID,
  (newVal, oldVal) => {
    if (newVal && !oldVal) {
      callTrackingAPIs()
    }
    if (!newVal) {
      safeLocalStorage.removeItem(ACCOUNT_TRACKER_CALLED_KEY)
    }
  }
)

watch(
  () => certification.value.isPassLoginAPI,
  isPassLoginAPI => {
    if (isPassLoginAPI) callTrackingAPIs()
  }
)

useBridge()

onMounted(() => {
  if (state.value.userID) {
    callTrackingAPIs()
  }

  googleAnalytics.initialize()

  /**
   * APP 橋接
   */
  if (state.value.isMobileAppActive) {
    const cricketUrl = `${window.location.origin}/#/?AppHomeBtn=true`
    sendMessage(
      JSON.stringify({
        sessionId: state.value.queryPass,
        platform: "cricket",
        cricketUrl
      })
    )
    sendMessage(JSON.stringify({ isShowHomeButton: "true" }))

    if (isLogin.value) {
      sendMessage(`{"userId":"${state.value.userID}"}`)
    }
  }
})
</script>

<style lang="scss" scoped></style>
